import useGetSystemSetting from "./useGetSystemSetting";

type SystemName = "admin" | "user" | "nok" | "mobility";

// 농기계 CRUD 시스템 설정
export const useSystemSetting = () => {
  const { data: systemData } = useGetSystemSetting();

  const systemSetting = (name: SystemName) => {
    if (!systemData) return null;
    return systemData.result.filter((el) => el.name === name)[0];
  };

  return systemSetting;
};
